import React from 'react';
import envcompany from 'envcompany';

class Footer extends React.Component {

    render(){
        return <div style={{position: 'absolute',bottom: 0,textAlign:'center',left:0,right:0,fontSize:12,paddingBottom:5}}>
            {envcompany.footer}
        </div>;

    }
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js